module.exports = __webpack_public_path__ + "media/images/tutorial_body_sp2-02-df4161b03b740cdc0e0bd12243c4b666.png";